<template>
  <section class="contact-hero relative overflow-hidden" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center text-white px-6">
      <span class="eyebrow eyebrow-light mb-5">Hablemos</span>
      <h1 class="hero-title text-5xl md:text-7xl font-bold text-white">Contáctame</h1>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="mt-6 text-base md:text-xl text-white/90 max-w-2xl italic font-light">
        Estoy aquí para responder tus dudas y agendar tu próxima cita
      </p>
    </div>
  </section>

  <section class="max-w-6xl mx-auto px-4 py-20">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
      <!-- Formulario -->
      <div class="contact-card">
        <span class="eyebrow mb-3">Escríbeme</span>
        <h2 class="font-display text-3xl md:text-4xl text-purple-custom font-semibold mt-2 mb-2">
          Ponerse en contacto
        </h2>
        <span class="divider-line mb-8"></span>

        <form class="space-y-6" @submit.prevent="handleSubmit">
          <div class="field">
            <label class="field-label" for="name">Tu nombre</label>
            <input type="text" id="name" class="input-underline" required v-model="form.nombre" placeholder="Como te llamas" />
          </div>
          <div class="field">
            <label class="field-label" for="phone">Número telefónico</label>
            <input type="tel" id="phone" class="input-underline" required v-model="form.telefono" placeholder="+56 9 ..." />
          </div>
          <div class="field">
            <label class="field-label" for="email">Email</label>
            <input type="email" id="email" class="input-underline" required v-model="form.correo" placeholder="tu@email.com" />
          </div>
          <div class="field">
            <label class="field-label" for="message">Mensaje</label>
            <textarea id="message" rows="4" class="input-underline" required v-model="form.mensaje" placeholder="Cuéntame en qué puedo ayudarte"></textarea>
          </div>
          <div class="pt-4">
            <button type="submit" class="btn-primary w-full justify-center uppercase tracking-widest">
              Enviar mensaje
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>
        </form>
      </div>

      <!-- Información de contacto -->
      <div class="contact-info">
        <span class="eyebrow mb-3">Mis datos</span>
        <h2 class="font-display text-3xl md:text-4xl text-purple-custom font-semibold mt-2 mb-2">
          Conecta conmigo
        </h2>
        <span class="divider-line mb-8"></span>

        <div class="space-y-6">
          <a href="mailto:jeshubeauty@gmail.com" class="info-card">
            <div class="info-icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <span class="info-label">Mail</span>
              <span class="info-value">jeshubeauty@gmail.com</span>
            </div>
          </a>

          <a href="tel:+56988424186" class="info-card">
            <div class="info-icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h2.28a1 1 0 01.95.68l1.5 4.49a1 1 0 01-.5 1.21l-2.26 1.13a11 11 0 005.52 5.52l1.13-2.26a1 1 0 011.21-.5l4.49 1.5a1 1 0 01.68.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z" />
              </svg>
            </div>
            <div>
              <span class="info-label">Teléfono</span>
              <span class="info-value">+56 9 8842 4186</span>
            </div>
          </a>
        </div>

        <div class="mt-10">
          <span class="eyebrow mb-4 block">Sígueme</span>
          <div class="flex gap-4 mt-2">
            <a href="https://www.instagram.com/jeshunails/" aria-label="Instagram" class="social-icon">
              <img src="../assets/1161953_instagram_icon.png" alt="Instagram" />
            </a>
            <a href="https://www.linkedin.com/in/majmasferrer/" aria-label="LinkedIn" class="social-icon">
              <img src="../assets/211909_linkedin_social_icon.png" alt="LinkedIn" />
            </a>
            <a href="https://www.youtube.com/@ItsJeshu" aria-label="YouTube" class="social-icon">
              <img src="../assets/youtube.png" alt="YouTube" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import backgroundImage from '@/assets/cristal1-scaled.jpg';
import emailjs from "emailjs-com";
import { useHead } from '@vueuse/head';

export default {
  name: 'ContactoPage',
  setup() {
    useHead({
      title: 'Contacto | Ponte en contacto con nosotros',
      meta: [
        { name: 'description', content: 'En nuestra página de contacto, estamos aquí para ayudarte con cualquier consulta o información que necesites. ¡No dudes en comunicarte con nosotros y estaremos encantados de atenderte!' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Contacto | Ponte en contacto con nosotros' },
        { property: 'og:description', content:  'En nuestra página de contacto, estamos aquí para ayudarte con cualquier consulta o información que necesites. ¡No dudes en comunicarte con nosotros y estaremos encantados de atenderte!' },
        { property: 'og:url', content: 'https://jeshubeauty.cl/contact' },
      ],
      link: [{ rel: 'canonical', href: 'https://jeshubeauty.cl/contact' }]
    });
  },
  data() {
    return {
      backgroundImage,
      form: {
        nombre: "",
        correo: "",
        telefono: "",
        mensaje: "",
      },
    };
  },
  methods: {
    async handleSubmit() {
      try {
        await emailjs.send(
          "service_p5qbcej",
          "template_xs94iuf",
          {
            nombre: this.form.nombre,
            correo: this.form.correo,
            telefono: this.form.telefono,
            mensaje: this.form.mensaje,
            para: this.form.correo,
          },
          "I_9KD45rikQFCurnJ"
        );

        alert("Correo enviado correctamente");
        this.clearForm();
      } catch (error) {
        alert("Ocurrió un error al enviar el correo.");
      }
    },
    clearForm() {
      this.form.nombre = "";
      this.form.correo = "";
      this.form.telefono = "";
      this.form.mensaje = "";
    },
  },
}
</script>

<style scoped>
.contact-hero {
  height: 55vh;
  min-height: 440px;
  background-size: cover;
  background-position: center;
}

.contact-card {
  background: #ffffff;
  border-radius: 1.5rem;
  padding: 2.25rem;
  box-shadow: 0 18px 50px rgba(115, 74, 145, 0.10);
  border: 1px solid rgba(184, 177, 189, 0.25);
}

@media (min-width: 768px) {
  .contact-card {
    padding: 2.75rem;
  }
}

.contact-info {
  padding: 1rem 0.5rem;
}

.field {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.35rem;
}

textarea.input-underline {
  resize: vertical;
  min-height: 120px;
  border: 2px solid rgba(184, 177, 189, 0.5);
  border-radius: 0.75rem;
  padding: 0.85rem 0.85rem;
}

textarea.input-underline:focus {
  border-color: #734A91;
  background: rgba(244, 239, 249, 0.4);
}

.info-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-radius: 1rem;
  border: 1px solid rgba(184, 177, 189, 0.3);
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(115, 74, 145, 0.12);
  border-color: rgba(115, 74, 145, 0.4);
}

.info-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f4eff9;
  color: #734A91;
  border-radius: 9999px;
  transition: background-color 0.35s ease, color 0.35s ease;
}

.info-card:hover .info-icon {
  background: #734A91;
  color: #ffffff;
}

.info-label {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #734A91;
  margin-bottom: 0.15rem;
}

.info-value {
  display: block;
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
}

.social-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: rgba(115, 74, 145, 0.10);
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
              background-color 0.35s ease,
              box-shadow 0.35s ease;
}

.social-icon img {
  width: 20px;
  height: 20px;
  transition: filter 0.3s ease;
}

.social-icon:hover {
  background: #734A91;
  transform: translateY(-3px);
  box-shadow: 0 10px 22px rgba(115, 74, 145, 0.28);
}

.social-icon:hover img {
  filter: brightness(0) invert(1);
}
</style>
